import React from "react";
import PropTypes from "prop-types";
import Brand from "../brand";
import InsurancePartners from "../../data/insurance-partners.json";

const BrandMarquee = ({ className }) => {
  // Duplicate the track so the marquee can loop seamlessly
  const logos = [...InsurancePartners, ...InsurancePartners];

  return (
    <div className={`insurance-marquee ${className || ""}`.trim()}>
      <div className="insurance-marquee-track">
        {logos.map((partner, index) => (
          <div className="insurance-marquee-item" key={`${partner.id}-${index}`}>
            <Brand data={partner} />
          </div>
        ))}
      </div>
    </div>
  );
};

BrandMarquee.propTypes = {
  className: PropTypes.string,
};

export default BrandMarquee;
